<template>
	<div class="contianer main-content">

		<div class="row">

			<div class="col-12 header-container text-center pb-3">
				<div class="checkmark" alt="Checkmark"></div>
			</div>
			
			<div class="col-12 header-container text-center pb-2">
				<h2 class="lrg primary-highlight">Thank you for your order!</h2>
			</div>

			<div class="col-12 col-sm-8 offset-sm-2 text-center">
				<img class="full-width shadow-bottom" src="./../assets/img/shadow_bottom.png" alt="shadow">
			</div>

		</div>
		
		<template v-if="$gstate.getFlowState().paymentMethod == 'GIFTCARD'">
			<div class="row">
				<div class="col-12 pt-2 text-center">
					<img :src="gcImage" :alt="$gstate.getPaymentMethodName(this.$gstate.getPaymentMethodSubtype()) + ' eGift Card'">
				</div>
			</div>

			<div class="row">
				<div class="col-12 pt-4 text-center">
					<h4 class="dark-highlight"><strong>${{ pq.fiatAmount | num2decimal }} <small>{{ pq.fiatCurrency }}</small> {{ $gstate.getPaymentMethodSubtypeName(this.$gstate.getPaymentMethodSubtype()) }} eGift Card</strong></h4>
				</div>
			</div>


			<div class="row panel-warning mt-4 mb-5 p-3">
				<div class="col-12 col-sm-1 text-center">
					<div class="exclamation" alt="Exclamation"></div>
				</div>
				<div class="col-12 col-sm-11 text-center text-warning">
					Once your personal information has been verified, payment instructions will be sent to <strong>{{ bi.emailAddress }}</strong>.
				</div>
			</div>
		</template>
		<template v-else>

			<div class="row">
				<div class="offset-0 col-12 offset-sm-3 col-sm-6 pt-3 text-center info-text">
					<p v-if="$gstate.getFlowState().paymentMethod == 'ETRANSFER'">
						We are reviewing and processing your order.<br />You will receive an email shortly with payment instructions from our payment partners <strong>Instant&nbsp;Digital&nbsp;Solutions</strong>.<br /><br />Please allow up to 1 hour to receive payment email.
					</p>
					<p v-else-if="$gstate.getFlowState().paymentMethod == 'FLEXEPIN'">
						Your Flexepin Voucher has been received and is processing.
					</p>
					<p v-else-if="$gstate.getFlowState().paymentMethod == 'BANKTRANSFER'">
						We are reviewing and processing your order.<br />You will receive an email shortly with payment instructions .<br /><br />Please allow up to 1 hour to receive payment email.
					</p>
					<p v-else-if="$gstate.getFlowState().paymentMethod == 'ETRANSFEROUT'">
						We are reviewing and processing your order.<br />You will receive an email shortly with payment instructions .<br /><br />Please allow up to 1 hour to receive payment email.
					</p>
					
				</div>
			</div>

			<div class="row">
				<div class="col-12 pt-4 text-center">
					<h4 class="dark-highlight"><strong>Summary</strong></h4>
				</div>
			</div>

			<div class="row">
				<div class="offset-0 col-12 col-sm-8 offset-sm-2 pt-4">
					<ul class="no-bullets pl-0 e-transfer-bullets">
						<template v-if="$gstate.getFlowState().paymentMethod == 'ETRANSFEROUT'">
							<li>You are selling: <strong class="dark-highlight">{{pq.cryptoAmount | num8decimal }} {{ pq.cryptoCurrency }}</strong></li>
							<li>You are receiving: <strong class="dark-highlight">${{ pq.fiatAmount | num2decimal }} {{ pq.fiatCurrency }}</strong></li>
							<li>Receiving email address: <strong class="dark-highlight"> {{ $gstate.getEmtEmailAddress() }} </strong></li>
						</template>
						<template v-else>
							<li>Order Total: <strong class="dark-highlight">${{ pq.fiatAmount | num2decimal }} {{ pq.fiatCurrency }}</strong></li>
							<li>{{ pq.cryptoCurrency }} Amount: <strong class="dark-highlight">{{pq.cryptoAmount | num8decimal }} {{ pq.cryptoCurrency }}</strong></li>
							<li>Receiving Address: <strong class="dark-highlight"> {{ $gstate.getCryptoAddress() }} </strong></li>
						</template>
					</ul>	
				</div>
			</div>

			<div class="row panel-warning mt-4 mb-5 p-3">
				<div class="col-12 col-sm-1 text-center">
					<div class="exclamation" alt="Exclamation"></div>
				</div>
				<div class="col-12 col-sm-11 text-center text-warning">
					<p v-if="$gstate.getFlowState().paymentMethod == 'ETRANSFER'">
						Once payment instructions are received, we must receive your payment within 1 hour or your transaction may be cancelled.  In the rare occurance of high transaction volumes, please allow up to 12 hours for your order to be reviewed.
					</p>
					<p v-else-if="$gstate.getFlowState().paymentMethod == 'FLEXEPIN'">
						Your coins will be delivered within the next 12 hours.
					</p>
					<p v-else-if="$gstate.getFlowState().paymentMethod == 'BANKTRANSFER'">
						Once payment instructions are received, we must receive your payment within 1 hour or your transaction may be cancelled.  In the rare occurance of high transaction volumes, please allow up to 12 hours for your order to be reviewed.
					</p>
					<p v-else-if="$gstate.getFlowState().paymentMethod == 'ETRANSFEROUT'">
						Once payment instructions are received, we must receive your payment within 1 hour or your transaction may be cancelled.  In the rare occurance of high transaction volumes, please allow up to 12 hours for your order to be reviewed.
					</p>
				</div>
			</div>
		</template>

		<div class="row mt-4">
			<div class="col-12 text-center">
				<a href="#" id="payment-etransfer-success-next" class="btn next-btn" v-on:click.prevent="done">Done</a>
			</div>
		</div>
	</div>
</template>

<script>

import { eventBus } from './../main'

export default {
    data(){
        return {
            pq: this.$gstate.getFlowState(),
			bi: this.$gstate.getBuyerInfo()
        }
	},
	computed: {
		gcImage: function(){
			return '/static/img/sell/' + this.$gstate.getPaymentMethodSubtype() + '.png';
		}
	},
	mounted(){
		eventBus.$emit('logGTMTransactionEvent', "transactionComplete");
	},
	created(){
		this.$emit('setLeaveNotification', false);
		this.$emit('setRateHoldTimer', false);
	},
    methods: {
        done: function (){
            this.$emit('reset', false);
            this.$gstate.redirectSuccess();
        }
    }
}
</script>
